import React from 'react';

class TextareaQuestion extends React.Component {
  state = {
    answer: '',
  };

  handleChange = (e) => {
    this.setState({ answer: e.target.value });
    const data = {};
    data[this.props.name] = e.target.value;
    this.props.setFormData(data);
  };

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.name !== this.props.name) {
      this.setState({ answer: '' });
    }
  }

  render() {
    var wrapClass = 'form-group';
    if (this.props.errorMsg) {
      wrapClass += ' error';
    }

    return (
      <div className={wrapClass}>
        <textarea
          className="form-control"
          value={this.state.answer}
          name={this.props.name}
          onChange={this.handleChange}
        />
        {this.props.errorMsg && (
          <div className="error">
            <div className="inner">
              {this.props.errorMsg}
            </div>
          </div>
        )}
      </div>
    )
  }
}

module.exports = TextareaQuestion;
